import { ViewportScroller } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-sample-accordion',
  templateUrl: './sample-accordion.component.html',
  styleUrls: ['./sample-accordion.component.scss']
})
export class SampleAccordionComponent implements OnInit {

  @Input() block: any[] = [];
  @Input() view: string = '';
  @Input() title: string = '';
  @Output() emitClickedField = new EventEmitter<any>();
  public id: string = '';
  public domainWebsite = environment.urlApi;
  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.helpersService.viewportScroll(event);
  }

  constructor(public helpersService: HelpersService) { }

  ngOnInit(): void {
    if (this.block) {
      //per attivarne una di default
      // this.id = this.block[0].id;
    }
  }

  itemClicked(itemClicked: any) {
    this.emitClickedField.emit(itemClicked);
  }

  public setColumnCTA(item: any): string {
    let countColumn: number[] = [];
    item.url_file_contenuti_corso ? countColumn.push(0) : null;
    item.link_dad ? countColumn.push(0) : null;
    item.link_e_learning ? countColumn.push(0) : null;
    switch (countColumn.length) {
      case 3:
        return 'col-12 col-lg-4';
      case 2:
        return 'col-12 col-lg-6';
      default:
        return 'col-12';
    }
  }

}
